function newsCardsCarousel() {
	var owl2 = $(".index-newsCards .owlCarousel");
	owl2.owlCarousel({
		loop:false,
		responsive:{
			0:{items:1},
			640:{items:2},
			1280:{items:3},
		},
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
	});
	$(".index-newsCards .right").click(function() {
		owl2.trigger('next.owl.carousel');
	});
	$(".index-newsCards .left").click(function() {
		owl2.trigger("prev.owl.carousel");
	});
}